// components/logistics/JobFilters.jsx
import React from 'react';
import { Filter, ChevronDown } from 'lucide-react';

const JobFilters = ({ filters, onFilterChange, skillCategories }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-4">
      <div className="flex items-center gap-4 flex-wrap">
        {/* Show/Hide Toggles */}
        <div className="flex items-center gap-3">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={filters.showQualified}
              onChange={(e) => onFilterChange({ ...filters, showQualified: e.target.checked })}
              className="rounded"
            />
            <span className="text-sm text-gray-700">Qualified Jobs</span>
          </label>
          
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={filters.showOpportunities}
              onChange={(e) => onFilterChange({ ...filters, showOpportunities: e.target.checked })}
              className="rounded"
            />
            <span className="text-sm text-gray-700">Opportunities</span>
          </label>
        </div>

        <div className="h-6 w-px bg-gray-300" />

        {/* Category Filter */}
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-gray-500" />
          <select
            value={filters.category}
            onChange={(e) => onFilterChange({ ...filters, category: e.target.value })}
            className="text-sm border-gray-300 rounded-md"
          >
            <option value="all">All Categories</option>
            {skillCategories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        {/* Sort By */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Sort by:</span>
          <select
            value={filters.sortBy}
            onChange={(e) => onFilterChange({ ...filters, sortBy: e.target.value })}
            className="text-sm border-gray-300 rounded-md"
          >
            <option value="matchScore">Best Match</option>
            <option value="tokenReward">Highest Reward</option>
            <option value="deadline">Urgency</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default JobFilters;